import { useNavigate } from "react-router-dom";
import { formatCurrency, formatDate } from "@/components/pcp";
import { StatusProposta } from "@/components/comercial/comercialUtil";

export function PropostasDoOrcamento({ propostas }) {
  const nav = useNavigate();
  return (
    <div className="pcp-card" style={{ padding: 16, marginTop: 20 }} data-testid="propostas-do-orcamento">
      <div className="font-display font-bold" style={{ fontSize: "1rem", marginBottom: 10 }}>Propostas emitidas desta revisão ({propostas.length})</div>
      {propostas.length === 0 ? <div style={{ color: "#71717A", fontSize: "0.85rem" }}>Nenhuma proposta emitida. Conclua a planilha e use "Emitir proposta".</div> : (
        <table className="pcp-table">
          <thead><tr><th>Número</th><th>Status</th><th>Emissão</th><th>Validade</th><th style={{ textAlign: "right" }}>Valor</th><th>Resultado</th><th>Contrato</th></tr></thead>
          <tbody>
            {propostas.map((p) => (
              <tr key={p.id} onClick={() => nav(`/propostas/${p.id}`)} style={{ cursor: "pointer" }} data-testid={`proposta-row-${p.id}`}>
                <td className="font-mono font-semibold">{p.numero}</td><td><StatusProposta status={p.status} /></td>
                <td className="font-mono text-xs">{formatDate(p.data_emissao)}</td><td className="font-mono text-xs">{p.validade_dias} dias</td>
                <td className="font-mono" style={{ textAlign: "right" }}>{formatCurrency(p.valor)}</td>
                <td className="font-mono text-xs">{formatDate(p.data_resultado)}</td>
                <td className="font-mono text-xs">{p.contrato_id ? "gerado" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
